// extracted by mini-css-extract-plugin
export default {"progressWrap":"ShopProgress_progressWrap__nTyl2"};